import { lazy } from "react";
const ViewLogs = lazy(() => import("../pages/admin/ViewLogs"));
const AdminDashboard = lazy(() => import("../pages/admin/AdminDashboard"));
const AdminTimeOffRequests = lazy(
  () => import("../pages/admin/AdminTimeOffRequests")
);
const AdminManageRewards = lazy(
  () => import("../pages/admin/AdminManageRewards")
);
const AdminMonitorSales = lazy(
  () => import("../pages/admin/AdminMonitorSales")
);
const AdminDailyActivity = lazy(
  () => import("../pages/admin/AdminDailyActivity")
);
const AdminSalesData = lazy(() => import("../pages/admin/AdminSalesData"));
const AdminExpenditures = lazy(
  () => import("../pages/admin/AdminExpenditures")
);
const AdminCustomers = lazy(() => import("../pages/admin/AdminCustomers"));
const AdminInvoices = lazy(() => import("../pages/admin/AdminInvoices"));
const AdminOrders = lazy(() => import("../pages/admin/AdminOrders"));
const AdminEditOrder = lazy(() => import("../pages/admin/AdminEditOrder"));
const CustomersData = lazy(() => import("../pages/admin/CustomersData"));
const AdminRevenue = lazy(() => import("../pages/admin/AdminRevenue"));
const AdminFabrics = lazy(() => import("../pages/admin/AdminFabrics"));
const AdminInvoiceData = lazy(() => import("../pages/admin/AdminInvoiceData"));
const AdminServiceTimes = lazy(
  () => import("../pages/admin/AdminServiceTimes")
);
const AdminTailors = lazy(() => import("../pages/admin/AdminTailors"));
const TailorDashboard = lazy(
  () => import("../pages/admin/TailorDashboard")
);
const BugReports = lazy(() => import("../pages/admin/BugReports"));
const BugReportDetails = lazy(
  () => import("../pages/admin/BugReportDetails")
);
const AdminTailorDetails = lazy(
  () => import("../pages/admin/AdminTailorDetails")
);
const AdminAssetsRegister = lazy(
  () => import("../pages/admin/AdminAssetsRegister")
);
const AdminAssetsEdit = lazy(() => import("../pages/admin/AdminAssetsEdit"));
const ManageAdmins = lazy(() => import("../pages/admin/ManageAdmins"));
const AdminPayments = lazy(() => import("../pages/admin/AdminPayments"));
const AdminShopSettings = lazy(() => import("../pages/admin/AdminShopSettings"));

export const adminRoutes = [
  {
    path: "/admin/payments",
    component: AdminPayments,
  },
  {
    path: "/admin/assets",
    component: AdminAssetsRegister,
  },
  {
    path: "/admin/assets/:id",
    component: AdminAssetsEdit,
  },
  {
    path: "/admin/orders",
    component: AdminOrders,
  },
  {
    path: "/admin/orders/:id/edit",
    component: AdminEditOrder,
  },
  // Admin Routes
  {
    path: "/admin/dashboard",
    component: AdminDashboard,
  },
  {
    path: "/admin/customers-data",
    component: CustomersData,
  },
  {
    path: "/admin/revenue",
    component: AdminRevenue,
  },
  {
    path: "/admin/fabrics",
    component: AdminFabrics,
  },
  {
    path: "/admin/invoice-data",
    component: AdminInvoiceData,
  },
  {
    path: "/admin/service-times",
    component: AdminServiceTimes,
  },
  {
    path: "/admin/tailors",
    component: AdminTailors,
  },
  {
    path: "/admin/tailor-dashboard",
    component: TailorDashboard,
  },
  {
    path: "/admin/bug-reports",
    component: BugReports,
  },
  {
    path: "/admin/bug-reports/:id",
    component: BugReportDetails,
  },
  {
    path: "/admin/tailors/time-off-requests",
    component: AdminTimeOffRequests,
  },
  {
    path: "/admin/tailors/:id",
    component: AdminTailorDetails,
  },
  {
    path: "/admin/tailors/:id/rewards",
    component: AdminManageRewards,
  },
  {
    path: "/admin/customers",
    component: AdminCustomers,
  },
  {
    path: "/admin/invoices",
    component: AdminInvoices,
  },
  {
    path: "/admin/expenses",
    component: AdminExpenditures,
  },
  {
    path: "/admin/tailors/sales-data/:id",
    component: AdminSalesData,
  },
  {
    path: "/admin/daily-activity",
    component: AdminDailyActivity,
  },
  {
    path: "/admin/users/sales-performance",
    component: AdminMonitorSales,
  },
  {
    path: "/admin/manage-admins",
    component: ManageAdmins,
  },
  {
    path: "/admin/view-logs",
    component: ViewLogs,
  },
  {
    path: "/admin/shop-settings",
    component: AdminShopSettings,
  },
];
